import React from 'react';

const Spacer = ({ height }) => <div style={{ height: height || 20 }} />;

export default Spacer;
